<template>
    <div class="macchine_quickconnext" style="margin: 20px">
        <v-card>
            <v-toolbar dense color="primary" dark align="center">
                <v-row class="mt-4">
                    <v-col cols="4" align="left" class="mt-1">
                        <v-toolbar-title>Lista Macchine</v-toolbar-title>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="filter" solo light dense append-icon="mdi-magnify" clearable placeholder="Filtra macchine"/>
                    </v-col>
                    <v-col cols="3" align="right" class="mt-1">
                        <v-btn small light @click="refresh">
                            <v-icon color="primary">mdi-autorenew</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1" align="right" class="mt-1">
                        <v-btn small light @click="$router.push('/home')">
                            <v-icon color="error">mdi-keyboard-backspace</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-container v-if="machines != null && devices != null">
                <v-data-table :headers="headers" :items="filtraMacchine(filter)" disable-pagination hide-default-footer >

                    <!-- Flag 4.0 -->
                    <template v-slot:[`item.flag_4_0`]="{ item }">
                        <v-btn small light @click="toggleMachineFlag(item)">
                            <v-icon :color="Number(item.flag_4_0) == 1 ? 'success' : 'error'">{{ Number(item.flag_4_0) == 1 ? "mdi-check" : "mdi-close" }}</v-icon>
                        </v-btn>                        
                    </template>

                    <!-- Nome gateway -->
                    <template v-slot:[`item.id_gateway`]="{ item }">
                        <span>{{ getGatewayName(item.id_gateway) }}</span>
                    </template>

                    <!-- Pulsante configurazione -->
                    <template v-slot:[`item.__config`]="{ item }">
                        <v-btn small light @click="openDialog(item)" :disabled="Number(item.flag_4_0) != 1">
                            <v-icon color="indigo">mdi-tune</v-icon>
                        </v-btn>
                    </template>
                    
                </v-data-table>
            </v-container>
        </v-card>

        <v-dialog persistent v-if="dialog.item!=null" v-model="dialog.show">
            <v-card>
                <v-toolbar dense color="primary" dark align="center">
                    <v-row >
                        <v-col cols="10" align="left" >
                            <v-toolbar-title>{{ dialog.item.cod_macchina}} | {{ dialog.item.des_macchina }}</v-toolbar-title>
                        </v-col>
                        <v-col cols="2" align="right" >
                            <v-btn small light @click="closeDialog">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container>
                    <v-tabs v-model="dialog.tabs">
                        <v-tab>Configurazione</v-tab>
                        <v-tab>Part Program</v-tab>
                        <v-tab>Collaudo Part Program</v-tab>
                    </v-tabs>
                    <v-divider class="my-3"/>
                    <v-tabs-items v-model="dialog.tabs">
                        <!-- Configurazione -->
                        <v-tab-item>
                            <GestioneInterfacceMacchina :id_macchina="dialog.item.id_macchina" />
                        </v-tab-item>

                        <!-- Part program -->
                        <v-tab-item>
                            <GestionePartProgram :id_macchina="dialog.item.id_macchina" />
                        </v-tab-item>

                        <!-- Collaudo part program -->
                        <v-tab-item>
                            <TestPartProgram :id_macchina="dialog.item.id_macchina" />
                        </v-tab-item>
                    </v-tabs-items>
                </v-container> 
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import TestPartProgram from "@/components/PRODUCTION/Impostazioni/PartProgramGet&Send";    // Modulo temporaneo, sostituire con un modulo di test fatto meglio
import GestioneInterfacceMacchina from './GestioneInterfacceMacchina.vue';
import GestionePartProgram from '../Gestione Part Program/GestionePartProgram.vue';
export default {
    name: 'ListaMacchine',
    components : {
        GestioneInterfacceMacchina,
        GestionePartProgram,
        TestPartProgram
    },
    data(){
        return{
            devices : null,
            dialog : {
                item : null,
                show : false,
                tabs : 0
            },
            filter : null,
            headers : [
                { text: 'ID', value: 'id_macchina' },
                { text: 'Codice', value: 'cod_macchina' },
                { text: 'Descrizione', value: 'des_macchina' },
                { text: 'Flag 4.0', value: 'flag_4_0' },
                { text: 'Gateway', value: 'id_gateway' },
                { text: 'Configura', value: '__config' },
            ],
            machines : null,
            NETWORK : null
        }
    },
    mounted(){
        this.NETWORK = this.$store.state.Network;
        this.refresh();
    },
    methods : {
        closeDialog(){
            this.dialog.item = null;
            this.dialog.show = false;
            this.dialog.tabs = 0;
        },
        filtraMacchine(filter){
            if((filter || '').trim() == ''){ return this.machines; }
            const result = new Array();
            this.machines.forEach((machine) => {
                const cod_match = (machine.cod_macchina || '').toLowerCase().indexOf(filter.toLowerCase().trim()) >= 0;
                const des_match = (machine.des_macchina || '').toLowerCase().indexOf(filter.toLowerCase().trim()) >= 0;
                if(cod_match || des_match){ result.push(machine); }
            });
            return result;
        },
        getCustomerDevices() {
            const that = this;            
            const request = {
                controller: "quickconnext",
                endpoint : 'connext',
                response: { parse: false },
                body: {
                    action: "getcustomerdevices",
                    token: localStorage.user_token,
                },
                method: "POST",
                on: {
                    load: function (response) {
                        that.devices = JSON.parse(response);
                    }
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        getGatewayName(id_gateway){
            id_gateway = Number(id_gateway);
            for(let i = 0; i < this.devices.length; i++){
                if(Number(this.devices[i].device_id) == id_gateway){
                    return this.devices[i].device_name;
                }
            }
            return null;
        },
        getListaMacchine() {
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint : 'connext',
                response: { parse: false },
                body: {
                    action: "getmachinelist",
                    token: localStorage.user_token,
                },
                method: "POST",
                on: {
                    load: function (response) {
                        that.machines = JSON.parse(response);
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        openDialog(item){
            this.dialog.item = item;
            this.dialog.show = true;
            this.dialog.tabs = 0;
        },
        refresh(){
            this.getCustomerDevices();
            this.getListaMacchine();
        },
        toggleMachineFlag(item) {
            const flag = (Number(item.flag_4_0) + 1) %2;         
            const request = {
                controller: "quickconnext",
                endpoint : 'connext',
                response: { parse: false },
                body: {
                    action: "setmachineflag",
                    token: localStorage.user_token,
                    flag_4_0 : flag,
                    machine_id : item.id_macchina
                },
                method: "PUT",
                on: {
                    load: function () {
                        item.flag_4_0 = flag;
                    }
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
    }
}
</script>
<style scoped>
.macchine_quickconnext{
    position: relative;
    max-height: calc(100vh - 88px);
    overflow: auto;
}
</style>